module.exports = __webpack_public_path__ + "assets/43c69cea44be80be1b3faae6b5c32e0b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo-transparent.png
// module id = 886
// module chunks = 0